// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"de7f4e9f","452":"02f6e668","667":"9e10e51c","785":"cd31df4b","977":"d76b428f"}[chunkId] + ".chunk.js";
};